export default __webpack_public_path__ + "static/media/CASH-OUT-OFF.84c18a58.png";